import { signal, Signal } from '@preact/signals';

export class ConfigStore {
  static _instance?: ConfigStore;

  static getInstance(): ConfigStore {
    return ConfigStore._instance!;
  }

  static createInstance(config: FormatConfig): ConfigStore {
    if (ConfigStore._instance) {
      return ConfigStore._instance;
    }

    ConfigStore._instance = new ConfigStore(config);
    return ConfigStore._instance;
  }

  _config: Signal<FormatConfig> = signal({} as FormatConfig);

  constructor(config: FormatConfig) {
    this.overrideConfiguration(config);
  }

  get config(): FormatConfig {
    return this._config.value;
  }

  alterConfiguration(config: Partial<FormatConfig>): void {
    const deepMerge = (target: any, source: any): any => {
      Object.keys(source).forEach(key => {
        if (
          source[key] &&
          typeof source[key] === 'object' &&
          !Array.isArray(source[key])
        ) {
          target[key] = deepMerge(
            target[key] ? { ...target[key] } : {},
            source[key]
          );
        } else {
          target[key] = source[key];
        }
      });
      return target;
    };
    this._config.value = deepMerge({ ...this._config.value }, config);
  }

  overrideConfiguration(config: FormatConfig): void {
    this._config.value = { ...config };
  }
}
